<template>
  <!-- eslint-disable max-len -->
  <svg
    width="58px"
    height="60px"
    viewBox="0 0 58 60"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>Printer Icon</title>
    <desc>Printer Icon</desc>
    <defs>
      <polygon points="0 0.476861538 57.8941607 0.476861538 57.8941607 25.8614769 0 25.8614769" />
    </defs>
    <g
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g transform="translate(-596.000000, -359.000000)">
        <g>
          <g transform="translate(479.000000, 267.000000)">
            <g transform="translate(117.000000, 92.000000)">
              <g>
                <g transform="translate(0.000000, 15.446215)">
                  <mask fill="white">
                    <use xlink:href="#path-1" />
                  </mask>
                  <g />
                  <path
                    d="M53.3659464,25.8614769 L4.52802976,25.8614769 C2.02680952,25.8614769 -0.00018452381,23.8334769 -0.00018452381,21.3310154 L-0.00018452381,5.00732308 C-0.00018452381,2.50486154 2.02680952,0.476861538 4.52802976,0.476861538 L53.3659464,0.476861538 C55.8671667,0.476861538 57.8941607,2.50486154 57.8941607,5.00732308 L57.8941607,21.3310154 C57.8941607,23.8334769 55.8671667,25.8614769 53.3659464,25.8614769"
                    :fill="active ? '#333366' : '#999999'"
                    mask="url(#mask-2)"
                  />
                </g>
                <g
                  transform="translate(5.535714, 0.676985)"
                  :fill="active ? '#333366' : '#999999'"
                >
                  <path d="M46.7526131,20.5537846 L42.1395179,20.5537846 L42.1395179,7.08424615 C42.1395179,5.8584 41.1430893,4.86147692 39.9187738,4.86147692 L6.90469643,4.86147692 C5.67945833,4.86147692 4.68302976,5.8584 4.68302976,7.08424615 L4.68302976,20.5537846 L0.0699345238,20.5537846 L0.0699345238,7.08424615 C0.0699345238,3.31347692 3.13672024,0.246092308 6.90469643,0.246092308 L39.9187738,0.246092308 C43.68675,0.246092308 46.7526131,3.31347692 46.7526131,7.08424615 L46.7526131,20.5537846 Z" />
                </g>
                <path
                  d="M49.9817798,32.0616 L7.91219643,32.0616 L7.91219643,53.8388308 C7.91219643,56.3412923 9.93919048,58.3692923 12.4404107,58.3692923 L45.4544881,58.3692923 C47.9557083,58.3692923 49.9817798,56.3412923 49.9817798,53.8388308 L49.9817798,32.0616 Z"
                  fill="#FFFFFF"
                />
                <path
                  d="M47.842872,24 C47.842872,25.1750769 46.8907292,26.1286154 45.7143899,26.1286154 C44.5398958,26.1286154 43.587753,25.1750769 43.587753,24 C43.587753,22.8249231 44.5398958,21.8713846 45.7143899,21.8713846 C46.8907292,21.8713846 47.842872,22.8249231 47.842872,24"
                  fill="#FFFFFF"
                />
                <path
                  d="M54.7625149,24 C54.7625149,25.1750769 53.810372,26.1286154 52.6340327,26.1286154 C51.4595387,26.1286154 50.5073958,25.1750769 50.5073958,24 C50.5073958,22.8249231 51.4595387,21.8713846 52.6340327,21.8713846 C53.810372,21.8713846 54.7625149,22.8249231 54.7625149,24"
                  fill="#FFFFFF"
                />
                <polygon
                  :fill="active ? '#333366' : '#999999'"
                  points="14.015506 39.1000615 43.8797619 39.1000615 43.8797619 37.4846769 14.015506 37.4846769"
                />
                <polygon
                  :fill="active ? '#333366' : '#999999'"
                  points="18.1875893 44.1769846 39.706756 44.1769846 39.706756 42.5616 18.1875893 42.5616"
                />
                <polygon
                  :fill="active ? '#333366' : '#999999'"
                  points="15.7749405 49.2539077 42.1184821 49.2539077 42.1184821 47.6385231 15.7749405 47.6385231"
                />
                <path
                  d="M45.4543036,59.7539077 L12.4402262,59.7539077 C8.67225,59.7539077 5.6063869,56.6865231 5.6063869,52.9157538 L5.6063869,31.1385231 L10.2194821,31.1385231 L10.2194821,52.9157538 C10.2194821,54.1416 11.2159107,55.1385231 12.4402262,55.1385231 L45.4543036,55.1385231 C46.678619,55.1385231 47.6750476,54.1416 47.6750476,52.9157538 L47.6750476,31.1385231 L52.2881429,31.1385231 L52.2881429,52.9157538 C52.2881429,56.6865231 49.2222798,59.7539077 45.4543036,59.7539077"
                  :fill="active ? '#333366' : '#999999'"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SvgPrinter',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
